// import PropTypes from 'prop-types';
import s from './ImageBlock.module.scss';
import classNames from 'classnames';
import Image from 'next/image';

const ImageBlock = ({
    src,
    description,
    extraClassNames,
    noCover,
    width,
    height,
}) => {
    return (
        <figure className={classNames(s.Root, extraClassNames)}>
            <div className={s.ImageWrapper}>
                <Image
                    src={src}
                    alt={''}
                    {...(!noCover ? { fill: true } : { width, height })}
                    style={{
                        borderRadius: 6,
                        ...(noCover
                            ? { width: '100%', height: 'auto' }
                            : { objectFit: 'cover' }),
                    }}
                />
            </div>
            {description && (
                <figcaption className={s.Caption}>{description}</figcaption>
            )}
        </figure>
    );
};

ImageBlock.propTypes = {};

export default ImageBlock;
